namespace $.$$ {
	$mol_style_define($bog_bzrl_app_profile_avatar, {
		width: '4rem',
		height: '4rem',
		padding: 0,
		border: {
			radius: '50%',
		},
		overflow: 'hidden',
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',

		Image: {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
			display: 'block',
		},

		Native: {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			opacity: 0,
			cursor: 'pointer',
		},
	})
}
